import imageUrlBuilder from '@sanity/image-url';
import {createClient} from '@sanity/client';

export const client = createClient({
  projectId: 'i1ndq4tu',
  dataset: 'production',
  apiVersion: '2021-10-21',
  useCdn: true,
  token: 'skiJoqJtqBD45l52vxrZKUyPDL00VdSgONRKFQBuegjXQ7Ump99DvIgkvpJdMpdnOq1U5TNsaCiJ6Wn6V0op39W4MuFdwAfGt1Bbym15brcV2kQVk73Vy9RyRkw8Qw8mD4VNtwDZSV62aFZCcBLoswzGGcr381p001lwxBNuvXwJFW8uAhaF',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

